// components/Footer.js
import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <h3>天津勃昂环保科技有限公司</h3>
            <p>专业环保解决方案提供商</p>
          </div>
          
          <div className="footer-links">
            <h4>快速链接</h4>
            <ul>
              <li><a href="#home">返回首页</a></li>
              <li><a href="#services">服务项目</a></li>
            </ul>
          </div>
          
          <div className="footer-contact">
            <h4>联系方式</h4>
            <p>手机：18822744310</p>
            <p>邮箱：Mr.Wang_Gx@163.com</p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} 备案编号：津ICP备2021004702号-4 保留所有权利.</p>
          <p>地址：天津市武清开发区福源道北侧麒麟商业中心2号楼2单元501室</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;